import React, { useEffect } from 'react';
import Icon from '../AppIcon';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const bgColor = type === 'success' ? 'bg-success' : type === 'error' ? 'bg-destructive' : 'bg-primary';
  const iconName = type === 'success' ? 'CheckCircle' : type === 'error' ? 'XCircle' : 'Info';

  return (
    <div className="fixed top-4 right-4 z-[100] animate-in slide-in-from-top-2 duration-300">
      <div className={`${bgColor} text-white px-6 py-4 rounded-lg shadow-2xl flex items-center gap-3 min-w-[300px] max-w-md`}>
        <Icon name={iconName} className="w-5 h-5 flex-shrink-0" />
        <p className="flex-1 font-medium">{message}</p>
        <button
          onClick={onClose}
          className="flex-shrink-0 hover:opacity-80 transition-opacity"
          aria-label="Fermer"
        >
          <Icon name="X" className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default Toast;